import { theme } from '@citygross/design-tokens';
import { useWindowSize } from '@citygross/utils';
import React, { useRef, useState, useEffect } from 'react';
import { SearchBar } from '../SearchBar/SearchBar.js';
import { Nav as Nav$1, NavContainer, NavChildContainer, NavMainLinks, SearchContainer, SearchResultOverlay } from './Nav.styles.js';

var Nav = function Nav(_a) {
  var _b, _c, _d, _e;

  var logo = _a.logo,
      maxWidth = _a.maxWidth,
      overlayTopPosition = _a.overlayTopPosition,
      height = _a.height,
      topPosition = _a.topPosition,
      mainLinks = _a.mainLinks,
      rightContent = _a.rightContent,
      inputIcon = _a.inputIcon,
      searchResultElement = _a.searchResultElement,
      searchCancelLabel = _a.searchCancelLabel,
      searchIcon = _a.searchIcon,
      searchPlaceHolder = _a.searchPlaceHolder,
      searchOnChange = _a.searchOnChange,
      searchValue = _a.searchValue,
      searchOnSubmit = _a.searchOnSubmit,
      onSearchClick = _a.onSearchClick,
      closeSearch = _a.closeSearch,
      mobileTopPosition = _a.mobileTopPosition,
      searchIsOpen = _a.searchIsOpen,
      searchInputRef = _a.searchInputRef,
      searchInputMobileRef = _a.searchInputMobileRef,
      onSearchBlur = _a.onSearchBlur,
      searchContainerRef = _a.searchContainerRef;
  var navContainerRef = useRef(null);
  var navChildContainerRef = useRef(null);
  var navRef = useRef(null);
  var width = useWindowSize().width;

  var _f = useState(width),
      localWidth = _f[0],
      setLocalWidth = _f[1];

  var _g = useState(0),
      elToRemove = _g[0],
      setElToRemove = _g[1];

  var widthRef = useRef(null);

  var checkWidth = function checkWidth() {
    var _a, _b, _c, _d, _e, _f, _g, _h;

    var containerWidth = (_b = (_a = navRef === null || navRef === void 0 ? void 0 : navRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) !== null && _b !== void 0 ? _b : 0;
    var containerScrollWidth = (_d = (_c = navRef === null || navRef === void 0 ? void 0 : navRef.current) === null || _c === void 0 ? void 0 : _c.scrollWidth) !== null && _d !== void 0 ? _d : 0;
    var childContainerWidth = (_f = (_e = navChildContainerRef === null || navChildContainerRef === void 0 ? void 0 : navChildContainerRef.current) === null || _e === void 0 ? void 0 : _e.offsetWidth) !== null && _f !== void 0 ? _f : 0; // assuming mainLinks max width

    var maxMainLinkWidth = (_h = (_g = theme.constants) === null || _g === void 0 ? void 0 : _g.navMainLinkWidth) !== null && _h !== void 0 ? _h : 105;
    var currentWidht = containerWidth;
    var removeLength = 0;

    while (currentWidht < containerScrollWidth) {
      currentWidht += maxMainLinkWidth;
      removeLength += 1;
    }

    if (width <= localWidth && (navRef === null || navRef === void 0 ? void 0 : navRef.current) && (containerScrollWidth > containerWidth || (navChildContainerRef === null || navChildContainerRef === void 0 ? void 0 : navChildContainerRef.current) && childContainerWidth > containerWidth)) {
      setElToRemove(function (prev) {
        return prev + removeLength;
      });
      widthRef.current = width;
    } else if (width > localWidth && ((widthRef === null || widthRef === void 0 ? void 0 : widthRef.current) && width >= (widthRef === null || widthRef === void 0 ? void 0 : widthRef.current) || elToRemove > 0)) {
      if (elToRemove) {
        setElToRemove(function (prev) {
          return prev - 1;
        });
      }
    } else ;

    setLocalWidth(width);
  };

  useEffect(function () {
    var debounce = setTimeout(function () {
      checkWidth();
    }, 300);
    return function () {
      clearTimeout(debounce);
    };
  }, [width, (_b = navRef === null || navRef === void 0 ? void 0 : navRef.current) === null || _b === void 0 ? void 0 : _b.offsetWidth, (_c = navChildContainerRef === null || navChildContainerRef === void 0 ? void 0 : navChildContainerRef.current) === null || _c === void 0 ? void 0 : _c.offsetWidth]);
  React.useEffect(function () {
    var handleClick = function handleClick(event) {
      var _a;

      if ((navContainerRef === null || navContainerRef === void 0 ? void 0 : navContainerRef.current) && !((_a = navContainerRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target))) {
        closeSearch && closeSearch();
      }
    };

    document.addEventListener('click', function (e) {
      return handleClick(e);
    }, true);
    return function () {
      document.removeEventListener('click', function (e) {
        return handleClick(e);
      }, true);
    };
  }, [navContainerRef]);
  var variants = {
    closed: {
      width: '0',
      transition: {
        duration: 0.1,
        ease: 'linear'
      }
    },
    open: {
      width: 'auto',
      transition: {
        duration: 0.1,
        ease: 'linear'
      }
    }
  };
  return React.createElement(Nav$1, {
    height: height,
    topPosition: topPosition,
    ref: navRef
  }, React.createElement(NavContainer, {
    maxWidth: maxWidth,
    ref: navContainerRef
  }, logo, React.createElement(NavChildContainer, {
    ref: navChildContainerRef
  }, React.createElement(React.Fragment, null, React.createElement(NavMainLinks, {
    variants: variants,
    animate: theme.constants && width < ((_d = theme.constants) === null || _d === void 0 ? void 0 : _d.headerBreakpoint) ? false : searchIsOpen ? 'closed' : 'open',
    initial: "open"
  }, (_e = mainLinks === null || mainLinks === void 0 ? void 0 : mainLinks.slice(0, (mainLinks === null || mainLinks === void 0 ? void 0 : mainLinks.length) - elToRemove)) === null || _e === void 0 ? void 0 : _e.map(function (link) {
    return link;
  })), React.createElement(SearchContainer, {
    isOpen: searchIsOpen,
    ref: searchContainerRef
  }, React.createElement(SearchBar, {
    mobileTopPosition: mobileTopPosition,
    icon: searchIcon,
    inputIcon: inputIcon,
    cancelLabel: searchCancelLabel,
    flexGrow: 1,
    onClick: function onClick() {
      onSearchClick && onSearchClick();
    },
    placeholder: searchPlaceHolder,
    onChange: searchOnChange,
    value: searchValue,
    inputRef: searchInputRef,
    searchInputMobileRef: searchInputMobileRef,
    searchOnSubmit: searchOnSubmit,
    isOpen: searchIsOpen,
    onBlur: onSearchBlur,
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Enter') {
        onSearchClick && onSearchClick();
      }
    }
  }, searchResultElement))), rightContent)), React.createElement(SearchResultOverlay, {
    show: searchIsOpen,
    overlayTopPosition: overlayTopPosition
  }));
};

export { Nav };